/*
 * @Date: 2026-01-31 10:00:00
 * @Description: 问卷相关API - 同步小程序端功能
 */
import { request } from "@/request/request";
import { parameterChange } from "@/utils/utils";

export default {
  // 问卷详情
  getSurveyInfo(data) {
    return request({
      url: "/survey/getSurveyInfo?" + parameterChange(data),
      method: "get",
      data,
    });
  },
};
